import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the PWA service worker.
//
// No auto-reload here on purpose. `clients.claim()` fires `controllerchange` on
// the very page that just registered the worker, so reloading from that event
// restarts the page on every uncontrolled load — first visit, hard refresh,
// private browsing, or after Safari/iOS purges site data (ITP 7-day cap). On
// iPhone that reads as the page reloading by itself, in a loop.
//
// A new version is picked up on the next navigation anyway: the worker serves
// the app shell, JS and CSS network-first, so fresh code is never held back.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
